import { Link } from "react-router-dom";
import { ArrowRight, Printer } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import CtaSection from "../components/CtaSection";
import { Reveal, RevealGroup, RevealItem } from "../components/Reveal";

const RESOURCES = [
  {
    to: "/resources/business-accounting-checklist",
    title: "Business Accounting Checklist",
    body: "Monthly, quarterly, and year-end habits that keep your business books reconciled, current, and ready for anything. Taxes, loans, or big decisions.",
    img: "/img/ill-checklists.webp",
    testId: "resources-link-business-checklist",
  },
  {
    to: "/resources/personal-tax-checklist",
    title: "Personal Tax Checklist",
    body: "What to gather through the year. Income forms, life changes, deductions paperwork. So personal tax preparation is calm instead of frantic.",
    img: "/img/ill-checklists.webp",
    testId: "resources-link-personal-checklist",
  },
  {
    to: "/resources/changing-bookkeepers",
    title: "Changing Bookkeepers: A Practical Guide",
    body: "When it makes sense to switch, what a clean handover involves, and the questions to ask any new bookkeeper. Including us.",
    img: "/img/ill-business.webp",
    testId: "resources-link-changing-bookkeepers",
  },
];

export default function Resources() {
  return (
    <>
      <Seo
        title="Accounting & Tax Resources and Checklists | Directive Optive Solutions"
        description="Free printable accounting checklists and plain-language guides: business accounting habits, personal tax preparation, and how to change bookkeepers smoothly."
        path="/resources"
      />
      <PageHeader
        eyebrow="Resources"
        title="Plain-language guides and checklists."
        lead="Free, practical, and honest. The checklists are printable with no email required. Take them, use them, and reach out only if and when you want a hand."
        image="/img/photo-books-desk.jpg"
        imageAlt="An accountant's desk with a calculator, notebook, and financial reports"
      />

      <section className="py-24 lg:py-32" data-testid="resources-list-section">
        <div className="container-shell">
          <RevealGroup className="grid gap-6 md:grid-cols-3">
            {RESOURCES.map((r) => (
              <RevealItem key={r.to} className="h-full">
                <Link to={r.to} data-testid={r.testId} className="group flex h-full flex-col border-t-2 border-olive/25 pt-7 transition-colors duration-300 hover:border-pine">
                  <h2 className="font-serif text-2xl text-olive">{r.title}</h2>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-moss">{r.body}</p>
                  <span className="mt-7 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-pine">
                    <Printer className="h-4 w-4" /> Open & print <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </section>

      <CtaSection heading="Checklists only go so far." body="When you’d like a team to take the work off your plate, book a consultation and we’ll talk about where things stand." />
    </>
  );
}
